import { useState } from "react";

const STAGES = {
  prospeccao: { label: "Prospecção", color: "#6366f1", emoji: "🎯" },
  contato:    { label: "Contato",    color: "#f59e0b", emoji: "📞" },
  reuniao:    { label: "Reunião",    color: "#3b82f6", emoji: "🤝" },
  proposta:   { label: "Proposta",   color: "#8b5cf6", emoji: "📋" },
  fechado:    { label: "Fechado",    color: "#10b981", emoji: "✅" },
  perdido:    { label: "Perdido",    color: "#ef4444", emoji: "❌" },
};

export function useNotificacoes() {
  const [notifs, setNotifs] = useState([]);

  const adicionar = (lead, stageAnterior, stageNovo) => {
    const s = STAGES[stageNovo];
    const notif = {
      id: Date.now(),
      lead: lead.nome,
      de: STAGES[stageAnterior]?.label || stageAnterior,
      para: s?.label || stageNovo,
      emoji: s?.emoji || "📌",
      color: s?.color || "#888",
      ts: new Date(),
    };
    setNotifs(prev => [notif, ...prev.slice(0, 19)]);
    setTimeout(() => setNotifs(prev => prev.filter(n => n.id !== notif.id)), 5000);
  };

  const limpar = (id) => setNotifs(prev => prev.filter(n => n.id !== id));

  return { notifs, adicionar, limpar };
}

export function NotificacaoToast({ notifs, limpar }) {
  return (
    <div style={{ position: "fixed", bottom: 28, right: 28, zIndex: 2000, display: "flex", flexDirection: "column", gap: 10, maxWidth: 340 }}>
      {notifs.map(n => (
        <div key={n.id} style={{
          background: "#2C2C2F", border: `1px solid ${n.color}44`,
          borderLeft: `4px solid ${n.color}`, borderRadius: 14,
          padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12,
          boxShadow: "0 8px 32px rgba(0,0,0,.5)",
          animation: "slideIn .25s cubic-bezier(.34,1.56,.64,1)"
        }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#F2F2F7", marginBottom: 3 }}>
              {n.emoji} Lead movido
            </div>
            <div style={{ fontSize: 12, color: "#8E8E93" }}>
              <span style={{ color: "#F2F2F7", fontWeight: 500 }}>{n.lead}</span> → <span style={{ color: n.color, fontWeight: 600 }}>{n.para}</span>
            </div>
          </div>
          <button onClick={() => limpar(n.id)} style={{ background: "none", border: "none", color: "#8E8E93", fontSize: 18, cursor: "pointer", lineHeight: 1, padding: 0, flexShrink: 0 }}>×</button>
        </div>
      ))}
      <style>{`@keyframes slideIn { from { opacity:0; transform: translateX(20px) scale(.95); } to { opacity:1; transform: translateX(0) scale(1); } }`}</style>
    </div>
  );
}
